import * as React from 'react';

import { createStyles, WithStyles, withStyles } from '@material-ui/core';
import { SnackbarOrigin } from '@material-ui/core/Snackbar/Snackbar';
import withWidth, { isWidthDown, WithWidth } from '@material-ui/core/withWidth';
import { SnackbarProvider } from 'notistack';
import { compose } from 'recompose';

const anchorOrigin: SnackbarOrigin = {
  vertical: 'bottom',
  horizontal: 'center',
};

const styles = () =>
  createStyles({
    overriddenInfo: {
      // color defined in https://cookbook.flipdish.com/85a996f8d/p/87cfc3-toast/b/8809dd/i/148078121
      backgroundColor: '#212121 !important',
    },
  });
const NotificationProvider = withWidth()(
  class extends React.Component<WithWidth & WithStyles<typeof styles>> {
    public render() {
      const isSmallScreen = isWidthDown('sm', this.props.width, true);
      return (
        <SnackbarProvider
          classes={{ variantInfo: this.props.classes.overriddenInfo }}
          dense={isSmallScreen ? true : false}
          maxSnack={3}
          anchorOrigin={anchorOrigin}
        >
          {this.props.children}
        </SnackbarProvider>
      );
    }
  }
);

export default compose<any, any>(withStyles(styles))(NotificationProvider);
